import parse from 'html-react-parser';

import { Avatar, Flex, HStack, Text, Box, Skeleton, Show, Hide } from '@vimeo/bokeh';

export const SkeletonRow = ({ w = '100%', h = '2xs' }) => {
  return <Skeleton w={w} h={h} borderRadius="pill" />;
};

export const SkeletonCircle = ({ w = 'md', h = 'md' }) => {
  return <Skeleton w={w} h={h} borderRadius="round" />;
};

export const UserNameAndPortrait = ({ name, image }: { name: string; image: string }) => (
  <>
    <Avatar alt={name} src={image} size="sm" nameProps={{ name }} />
    <Text as="span" variant="heading-xs">
      {name}
    </Text>
  </>
);

export const VideoDetailsSkeleton = ({
  title = '',
  description,
  user,
  showUserInfo = false,
}: {
  title?: string;
  description?: string;
  user?: { name?: string; image?: string };
  showUserInfo?: boolean;
}) => (
  <Flex direction="column" gap={100} p={{ base: 200, md: 300 }}>
    {title ? (
      <Text
        as="h1"
        variant={{ base: 'heading-md', md: 'heading-lg', xl: 'heading-xl' }}
        minW="0"
        style={{ hyphens: 'auto' }}
      >
        {title}
      </Text>
    ) : (
      <SkeletonRow w="90%" h="md" />
    )}
    <HStack my={100}>
      {showUserInfo && user?.name && user?.image ? (
        <UserNameAndPortrait name={user.name} image={user.image} />
      ) : (
        <>
          <SkeletonCircle h="xs" w="xs" />
          <SkeletonRow w="30%" h="xs" />
        </>
      )}
    </HStack>

    <Show above="md">
      {description ? (
        <Box fontSize="text-sm" lineHeight="text-sm">
          {parse(description)}
        </Box>
      ) : null}
      <SkeletonRow w="90%" h="2xs" />
      <SkeletonRow w="100%" h="2xs" />
      <SkeletonRow w="90%" h="2xs" />
      <SkeletonRow w="30%" h="2xs" />
    </Show>
    <Hide above="md">
      {description ? (
        <Box fontSize="text-sm" lineHeight="text-sm" mb={100}>
          {parse(description)}
        </Box>
      ) : null}
      <>
        <SkeletonRow w="90%" h="2xs" />
        <SkeletonRow w="100%" h="2xs" />
        <SkeletonRow w="90%" h="2xs" />
        <SkeletonRow w="30%" h="2xs" />
        <HStack my={100}>
          <SkeletonRow w="20%" h="xs" />
          <SkeletonRow w="20%" h="xs" />
          <SkeletonRow w="20%" h="xs" />
        </HStack>
      </>
    </Hide>
  </Flex>
);
